import React from "react";

const AboutProduct = () => {
  return (
    <div className="about_product">
      <div className="about_product_sec container flex-col-center">
        <h1 className="dc-script">About our fruit</h1>
        <div className="about_product_main dm-sans">
          <div className="about_product_main_l">
            <div>
              <div className="icon_div shadow">
                <i className="bi bi-droplet"></i>
              </div>
              <h4>No Insecticide Used</h4>
              <p>Vestibulum isea ullamcorpies isee ullamcorpies ullamies</p>
            </div>
            <div>
              <div className="icon_div shadow">
                <i className="bi bi-droplet"></i>
              </div>
              <h4>Grow in Greenhouse</h4>
              <p>Vestibulum isea ullamcorpies isee ullamcorpies ullamies</p>
            </div>
          </div>

          <div className="about_product_main_c">
            <img src="/img/products/abt-prod.png" alt="about product" />
          </div>
          <div className="about_product_main_r">
            <div>
              <div className="icon_div shadow">
                <i className="bi bi-droplet"></i>
              </div>
              <h4>Grow in Greenhouse</h4>
              <p>Vestibulum isea ullamcorpies isee ullamcorpies ullamies</p>
            </div>
            <div>
              <div className="icon_div shadow">
                <i className="bi bi-droplet"></i>
              </div>
              <h4>No Insecticide Used</h4>
              <p>Vestibulum isea ullamcorpies isee ullamcorpies ullamies</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutProduct;
